import React from "react";
import { Button } from "@/ui-components/ui/button";
import { Dialog, DialogContent } from "@/ui-components/ui/dialog";
import { CirclePlay, Rocket, Sparkles } from "lucide-react";
import { PLAN_CONFIG, type PlanType } from "./shared";

interface OnboardingReadyDialogProps {
  open?: boolean;
  plan: PlanType;
  onStartTour: () => void;
}

export const OnboardingReadyDialog = ({
  open = true,
  plan,
  onStartTour,
}: OnboardingReadyDialogProps) => {
  const currentPlanConfig = PLAN_CONFIG[plan];

  return (
    <Dialog open={open} onOpenChange={() => undefined}>
      <DialogContent
        isClosable={false}
        className="w-[calc(100%-2rem)] overflow-hidden rounded-3xl sm:rounded-3xl border border-gray-100 p-0 shadow-xl sm:w-full sm:max-w-md bg-white"
        onEscapeKeyDown={(event) => event.preventDefault()}
        onInteractOutside={(event) => event.preventDefault()}
      >
        <div className="p-8 text-center flex flex-col items-center">
          <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-50 text-blue-600">
            <Rocket className="h-7 w-7" />
          </div>
          
          <h2 className="mb-3 text-2xl font-bold tracking-tight text-gray-900">
            {currentPlanConfig.title}
          </h2>
          
          <p className="mb-8 text-sm leading-relaxed text-gray-500">
            {currentPlanConfig.subtitle}
          </p>

          <div className="w-full rounded-xl border border-gray-100 bg-gray-50 p-5 text-left mb-8">
            <div className="flex gap-4">
              <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white border border-gray-200 shadow-sm text-gray-700">
                <Sparkles className="h-4 w-4" />
              </div>
              <div>
                <h3 className="text-sm font-semibold text-gray-900">Dein erster Post in 2 Minuten</h3>
                <p className="mt-1 text-sm leading-relaxed text-gray-500">
                  Wir haben Demo-Daten für dich vorbereitet. So kannst du direkt ausprobieren, wie einfach es ist, Inhalte in dein Template einzufügen und zu posten.
                </p>
              </div>
            </div>
          </div>

          <Button 
            onClick={onStartTour} 
            className="w-full h-11 bg-blue-600 hover:bg-blue-700 text-white rounded-xl transition-all"
          >
            <CirclePlay className="mr-2 h-5 w-5" />
            Tour starten
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export type { OnboardingReadyDialogProps };
